export const PDF_NAME = 'ScanMe_Subscriptions.pdf';
